import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import SelectBox from '../../common/selectBox/SelectBox';
import I18n from 'i18n-react';
import './InstallmentsSelect.css';
import * as installmentService from '../../../services/installments/InstallmentService';
import InstallmentsToInstallmentsModelAssembler from '../../../services/installments/InstallmentsToInstallmentsModelAssembler';
import $ from 'jquery';

const propTypes = {
  id: PropTypes.string.isRequired,
  changeValue: PropTypes.func.isRequired,
  required: PropTypes.bool
};

class InstallmentsSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: true,
      options: [],
      selectedInstallment: null,
      selectedText: '',
      value: ''
    };
  }

  componentDidMount() {
    this.getInstallments();
  }

  validate = () => {
    let selectedInstallment = this.state.selectedInstallment;
    if (selectedInstallment === null) {
      this.setState({ isValid: false });
      return false;
    }
    this.setState({ isValid: true });
    return true;
  };

  generateInstallmentText = (option) => {
    const installments = option.installments.slice(0, 2);
    let installmentText = '';

    if (option.interestsInstallment == 0) {
      installmentText = `${option.installmentNumber} x R$ ${this.getValueFormatted(installments[0])}`;
    } else {
      installmentText = `${option.installmentNumber} x R$ ${this.getValueFormatted(installments[0])} ${I18n.translate("components.checkoutInfo.installments.juros")}`;
    }


    return installmentText;
  };

  toggleLoadingModal() {
    var I18n = require('i18n-react').default;
    $('#loader-message').text(I18n.translate('loading'));
    window.showLoadingScreen();
  }

  getInstallments() {
      let installments = [];
      
      try {
        this.toggleLoadingModal();
          installmentService.installments(this.assembleRequest())
          .then(response => {
              this.toggleLoadingModal();
              const options = InstallmentsToInstallmentsModelAssembler.assembleInstalments(response);
              this.setState({ options: options });
            });
      } catch (error) {
        this.toggleLoadingModal();
      }
      return installments;
  }

  assembleRequest() {
      let taxesAndMoney = this.props.quotationJourney.values.totalTaxesAndMoney.toFixed(2);
  
      return {
        profileName: "site_apm",
        methodCode: "VI",
        totalAmount: taxesAndMoney,
        taxAmount: 0
      };
    }

  assembleInstalments() {
      const { selectedInstallment } = this.state;
  
      if (selectedInstallment !== '') {
        let quotationJourney = {
          installment: {
            totalAmount: selectedInstallment.total,
            installmentValue: selectedInstallment.installments[0],
            installmentNumber: selectedInstallment.installmentNumber
          }
        }
  
        this.setState({ quotationJourney: quotationJourney });
        this.props.changeValue(selectedInstallment);
      }
    }

  getValueFormatted(value) {
     return value
       .toFixed(2)
       .replace('.', ',')
       .replace(/(\d)(?=(\d{3})+,)/g, '$1.');
  }  

  renderMessageInvalid() {
    if (!this.state.isValid) {
      return (
        <Row>
          <Col xs={12} className="Field__message CardValidDate__error">
            <span className="CardValidDate__invalidField">
              {I18n.translate('components.checkoutInfo.installments.invalidInstallmentErrorMessage')}
            </span>
          </Col>
        </Row>
      );
    }
  }

  getInstallmentsOptions() {
    let installments = [];
    this.state.options.map(option => {
      installments.push(this.generateInstallmentText(option))
    })

    return installments.map(String);
  }  

  findInstallmentObject = (selectedText) => {
    const selectedInstallment = this.state.options.find(item => {
      const generatedText = this.generateInstallmentText(item);
      generatedText.includes('com juros') ? generatedText.replace('com juros', '') : generatedText;
      return selectedText.trim() === generatedText.trim();
    });
     this.setState({ selectedInstallment }, () => {
      this.assembleInstalments();
    }
    );
  };

  handleSelectChange = (event) => {
    const selectedText = event;
    this.setState({ selectedText: selectedText }, () => {
      this.findInstallmentObject(selectedText);
      if (this.state.selectedInstallment) {
        this.props.changeValue(this.state.selectedInstallment);
      } else {
        this.props.changeValue(null);
      }
    });
  };


  renderCombo() {
    const { options } = this.state;
    
    if (options.length > 0) {
      return (
        <div>
          <Row id={`instalmentsInput-${this.props.id}`}>          
            <Col xs={12}>            
             <SelectBox
                id={`installmentsInputSelect`}
                label="components.checkoutInfo.installments.label"
                required={true}
                errorMessage="components.checkoutInfo.cardValidDate.monthRequired"
                placeholder="components.checkoutInfo.installments.placeholder"
                values={this.getInstallmentsOptions()}
                ref={c => {
                  this.installmentField = c;
                }}
                changeValue={this.handleSelectChange}
                onBlurFieldToIco={this.props.onBlurFieldToIco}                
                styleFieldIdentifier = {'styleFieldMonth'}
                iconIdentifier = {'iconMonth'} 
                callCenterMode={this.props.callCenterMode} 
              />
            </Col>
          </Row>
          {this.renderMessageInvalid()}
        </div>
      );
    }
  }

  render() {
    return <div>{this.renderCombo()}</div>;
  }
}

InstallmentsSelect.propTypes = propTypes;

export default InstallmentsSelect;



// WEBPACK FOOTER //
// ./src/components/checkoutInfo/installments/InstallmentsSelect.jsx